import * as React from 'react'
import { useState, useEffect } from "react"
import { FORMAT_DATE_BACK, formatDate, postSubmit } from 'ui-seeker/utils'

import { SelectLoading } from "app/components/loading"
import { PARITY_URL } from 'app/@common/constants'
import RadioElements from './RadioElements'


export default function RadioDevicesMultiButton(props) {

    const { title='', items, value, onChange, market, date, customDates, sites, nights, occupancy, refresh, disabled } = props
    const [devices, setDevices] = useState('')

    useEffect(() => {
        if (!!date && !!occupancy && !!nights) {
            postSubmit(PARITY_URL.DEVICES, {
                market: market,
                dateRange: date,
                id_site: sites,
                nights: nights, 
                occupancy: occupancy, 
                ...refresh && { refresh_cache: refresh },
                ...date === 'custom' && {
                    startDate: formatDate(customDates[0], { format: FORMAT_DATE_BACK }),
                    endDate: formatDate(customDates[1], { format: FORMAT_DATE_BACK })
                }
            }).then(data => {
                setDevices(data)
            })
        } else setDevices(null)
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [market, date, nights, occupancy, refresh])

    const listItems = !!devices && items.map(a => ({
        value: a.value,
        label: a.label
    }))

    if (!listItems) return <SelectLoading />

    return <div className="switch-field">
        <div className="switch-title">{title}</div>
        { !!devices && listItems.map((item, id) => (
            <RadioElements item={item} key={id} id={id} onChange={onChange} value={value} devices={devices} disabled={disabled} />
        )) }
        { listItems.length && <>
            <input
                disabled={!devices.length || disabled}
                type="radio"
                id="switch-all"
                name="switch-toggle"
                value=""
                onChange={() => devices.length && onChange('')}
                checked={(Array.isArray(value) ? value.join().toString() : value.toString()) === ''}
            />
            <label htmlFor="switch-all" className={disabled ? 'multi-button-disabled' : ''}>All</label>
        </> }
    </div>
}